// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SubMenu_wrapper__zsJWk","list":"SubMenu_list__PXBRJ","listItem":"SubMenu_listItem__MA1xS","listItemLink":"SubMenu_listItemLink___QqRF"};